"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxAgree = void 0;
var react_1 = __importDefault(require("react"));
var CheckboxAgree_module_scss_1 = __importDefault(require("./CheckboxAgree.module.scss"));
var react_router_dom_1 = require("react-router-dom");
var CheckMarker_1 = require("../checkMarker/CheckMarker");
var CheckboxAgree = function (props) {
    var id = props.id, register = props.register, isError = props.isError;
    return (react_1.default.createElement("label", { className: CheckboxAgree_module_scss_1.default.checkbox_label, htmlFor: id },
        react_1.default.createElement("input", __assign({ className: CheckboxAgree_module_scss_1.default.checkbox_label__checkbox }, register, { type: "checkbox", id: id })),
        react_1.default.createElement("div", { className: "".concat(CheckboxAgree_module_scss_1.default.checkbox_label__checkbox_custom, " ").concat(isError ? 'field_error' : '') },
            react_1.default.createElement(CheckMarker_1.CheckMarker, null)),
        react_1.default.createElement("p", { className: CheckboxAgree_module_scss_1.default.checkbox_label__text },
            "\u0421\u043E\u0433\u043B\u0430\u0441\u0435\u043D \u043D\u0430",
            ' ',
            react_1.default.createElement(react_router_dom_1.Link, { className: CheckboxAgree_module_scss_1.default.checkbox_label__link, to: '/' }, "\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445"))));
};
exports.CheckboxAgree = CheckboxAgree;
